(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(77149);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProducts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);


function useProducts(queryStringify) {
    const [products, setProducts] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const { data: productData , error , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(queryStringify ? "".concat("https://api.lamptan.co.th", "/v1/public/products?").concat(queryStringify) : null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (productData) {
            setProducts(productData.docs);
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
    }, [
        productData
    ]);
    return {
        productData,
        products: products,
        isProductsLoading: !error && !productData,
        isValidating
    };
}


/***/ }),

/***/ 77149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(36158);
// EXTERNAL MODULE: ./components/home/HomeBannerSection.tsx
var HomeBannerSection = __webpack_require__(63695);
// EXTERNAL MODULE: ./components/home/HomeFeaturedCategoriesSection.tsx
var HomeFeaturedCategoriesSection = __webpack_require__(58920);
// EXTERNAL MODULE: ./components/home/HomeProductCategorySection.tsx
var HomeProductCategorySection = __webpack_require__(48444);
// EXTERNAL MODULE: ./components/products/ProductListSwiper.tsx
var ProductListSwiper = __webpack_require__(77412);
// EXTERNAL MODULE: ./hooks/useProducts.ts
var useProducts = __webpack_require__(7980);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/home/HomeProductList.tsx





function HomeProductList(param) {
    let { query  } = param;
    const { products  } = (0,useProducts/* default */.Z)(query);
    ;
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListSwiper/* default */.Z, {
            products: products,
            breakpoints: {
                300: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                    slidesPerGroup: 2
                },
                768: {
                    slidesPerView: 4.5,
                    spaceBetween: 20,
                    slidesPerGroup: 4
                },
                992: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                    slidesPerGroup: 5
                }
            }
        })
    });
}
/* harmony default export */ var home_HomeProductList = (HomeProductList);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(35656);
;// CONCATENATED MODULE: ./components/home/HomeSectionHeader.tsx





function HomeSectionHeader(param) {
    let { title , viewAllLink  } = param;
    // use i18n
    const { t  } = (0,esm/* useTranslation */.$G)([
        "home"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        justifyContent: "space-between",
        mb: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                fontSize: {
                    base: "2xl",
                    md: "3xl"
                },
                color: "primary.500",
                fontWeight: 400,
                textTransform: "uppercase",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: viewAllLink,
                    passHref: true,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: viewAllLink,
                    passHref: true,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                        fontSize: "xl",
                        textTransform: "uppercase",
                        children: t("home.more")
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var home_HomeSectionHeader = (HomeSectionHeader);

// EXTERNAL MODULE: ./components/home/HomeSingleBanner.tsx
var HomeSingleBanner = __webpack_require__(77909);
// EXTERNAL MODULE: ./hooks/useCatchError.ts
var useCatchError = __webpack_require__(65633);
// EXTERNAL MODULE: ./layouts/RootLayout.tsx + 10 modules
var RootLayout = __webpack_require__(89806);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./respository/page.service.ts
var page_service = __webpack_require__(17032);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./hooks/useProductCategories.ts
var useProductCategories = __webpack_require__(88062);
// EXTERNAL MODULE: ./hooks/useProductMainCategories.ts
var useProductMainCategories = __webpack_require__(68758);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
;// CONCATENATED MODULE: ./pages/index.tsx


























const HomePage = (param)=>{
    let { pageProp  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "home",
        "common"
    ]);
    // use catch error
    const catchError = (0,useCatchError/* default */.Z)();
    // use product main categories
    const { productMainCategories  } = (0,useProductMainCategories/* default */.Z)();
    // use product categories
    const { productCategories  } = (0,useProductCategories/* default */.Z)();
    // use router
    const router = (0,next_router.useRouter)();
    // init page
    const [page, setPage] = (0,react.useState)(pageProp);
    // init main slider
    const [mainSlider, setMainSlider] = (0,react.useState)([]);
    // init first banner
    const [firstBanner, setFirstBanner] = (0,react.useState)(null);
    // init featuredCategories
    const [featuredCategories, setFeaturedCategories] = (0,react.useState)([]);
    // init spacial banner
    const [spacialBanner, setSpacialBanner] = (0,react.useState)(null);
    // init product spacial price query string
    const [productSpacialPriceQueryString, setProductSpacialPriceQueryString] = (0,react.useState)("");
    // init product best seller ids
    const [productBestSellerQueryString, setProductBestSellerQueryString] = (0,react.useState)("");
    // init product new arrival query string
    const [productNewArrivalQueryString, setProductNewArrivalQueryString] = (0,react.useState)("");
    // init topBottomBanner
    const [topBottomBanners, setTopBottomBanners] = (0,react.useState)([]);
    const [catalogBannersTop, setCatalogBannersTop] = (0,react.useState)([]);
    // init catalogBanners
    const [catalogBanners, setCatalogBanners] = (0,react.useState)([]);
    const [catalogBannersBottom, setCatalogBannersBottom] = (0,react.useState)([]);
    // init topBottomBanner
    const [bottomBanners, setBottomBanners] = (0,react.useState)([]);
    // init product category section
    const [productCategorySections, setProductCategorySections] = (0,react.useState)([]);
    // get paage
    const { data: pageHomeData  } = (0,dist/* default */.ZP)("".concat("https://api.lamptan.co.th", "/v1/pages/permalink/home"));
    (0,react.useEffect)(()=>{
        const getPage = async ()=>{
            try {
                // get page
                const page = await page_service/* PageRepository.findOneByPermalink */.h.findOneByPermalink("home");
                ;
                setPage(page);
            } catch (error) {
                catchError(error);
            }
        };
        getPage();
    }, []);
    (0,react.useEffect)(()=>{
        if (pageHomeData) {
            setPage(pageHomeData);
        }
    }, [
        pageHomeData
    ]);
    (0,react.useEffect)(()=>{
        if (page) {
            if (page.customFields) {
                // ********** Main slider **********
                const mainSlider = page.customFields.find((field)=>field.key === "mainSlider");
                if (mainSlider && !(0,lodash.isEmpty)(mainSlider)) {
                    const mainSliderValue = JSON.parse(mainSlider.value);
                    ;
                    setMainSlider(mainSliderValue);
                }
                // ********** First banner **********
                const firstBanner = page.customFields.find((field)=>field.key === "firstBanner");
                // if first banner
                if (firstBanner && !(0,lodash.isEmpty)(firstBanner)) {
                    const firstBannerValue = JSON.parse(firstBanner.value);
                    ;
                    setFirstBanner(firstBannerValue);
                }
                // ********** Featured categories **********
                const featuredCategories = page.customFields.find((field)=>field.key === "featuredCategories");
                // if featured categories
                if (featuredCategories && !(0,lodash.isEmpty)(featuredCategories)) {
                    const featuredCategoriesValue = JSON.parse(featuredCategories.value);
                    ;
                    setFeaturedCategories(featuredCategoriesValue);
                }
                // ********** Spacial banner **********
                const spacialBanner = page.customFields.find((field)=>field.key === "spacialBanner");
                // if spacial banner
                if (spacialBanner && !(0,lodash.isEmpty)(spacialBanner)) {
                    const spacialBannerValue = JSON.parse(spacialBanner.value);
                    ;
                    setSpacialBanner(spacialBannerValue);
                }
                // ********** Best seller products **********
                const bestSellerProducts = page.customFields.find((field)=>field.key === "bestSellerProducts");
                if (bestSellerProducts && !(0,lodash.isEmpty)(bestSellerProducts)) {
                    const bestSellerProductsValue = JSON.parse(bestSellerProducts.value);
                    ;
                    setProductBestSellerQueryString(query_string.stringify({
                        ids: bestSellerProductsValue.join(","),
                        limit: 100,
                        include: "productBadge"
                    }));
                }
                // ********** Product spacial price **********
                const spacialPriceProducts = page.customFields.find((field)=>field.key === "spacialProducts");
                if (spacialPriceProducts && !(0,lodash.isEmpty)(spacialPriceProducts)) {
                    const spacialPriceProductsValue = JSON.parse(spacialPriceProducts.value);
                    ;
                    setProductSpacialPriceQueryString(query_string.stringify({
                        ids: spacialPriceProductsValue.join(","),
                        limit: 100,
                        include: "productBadge"
                    }));
                }
                // ********** Product new arrival **********
                const newArrivalProducts = page.customFields.find((field)=>field.key === "newArrivalProducts");
                if (newArrivalProducts && !(0,lodash.isEmpty)(newArrivalProducts)) {
                    const newArrivalProductsValue = JSON.parse(newArrivalProducts.value);
                    ;
                    setProductNewArrivalQueryString(query_string.stringify({
                        ids: newArrivalProductsValue.join(","),
                        limit: 100,
                        include: "productBadge"
                    }));
                }
                // ********** Product category section **********
                const productCategorySection = page.customFields.find((field)=>field.key === "productCategorySection");
                if (productCategorySection && !(0,lodash.isEmpty)(productCategorySection)) {
                    const productCategorySectionValue = JSON.parse(productCategorySection.value);
                    ;
                    setProductCategorySections(productCategorySectionValue);
                }
                // ********** Top bottom banner **********
                const topBottomBanners = page.customFields.find((field)=>field.key === "topBottomBanners");
                if (topBottomBanners && !(0,lodash.isEmpty)(topBottomBanners)) {
                    const topBottomBannersValue = JSON.parse(topBottomBanners.value);
                    ;
                    setTopBottomBanners(topBottomBannersValue);
                }
                // ********** Catalog banners top **********
                const catalogBannersTop = page.customFields.find((field)=>field.key === "catalogBannersTop");
                ;
                if (catalogBannersTop && !(0,lodash.isEmpty)(catalogBannersTop)) {
                    const catalogBannersTopValue = JSON.parse(catalogBannersTop.value);
                    ;
                    setCatalogBannersTop(catalogBannersTopValue);
                }
                // ********** Catalog banners **********
                const catalogBanners = page.customFields.find((field)=>field.key === "catalogs");
                if (catalogBanners && !(0,lodash.isEmpty)(catalogBanners)) {
                    const catalogBannersValue = JSON.parse(catalogBanners.value);
                    ;
                    setCatalogBanners(catalogBannersValue);
                }
                // ********** Catalog banners bottom **********
                const catalogBannersBottom = page.customFields.find((field)=>field.key === "catalogBannersBottom");
                if (catalogBannersBottom && !(0,lodash.isEmpty)(catalogBannersBottom)) {
                    const catalogBannersBottomValue = JSON.parse(catalogBannersBottom.value);
                    ;
                    setCatalogBannersBottom(catalogBannersBottomValue);
                }
                // ********** Bottom banner **********
                const bottomBanners = page.customFields.find((field)=>field.key === "bottomBanners");
                if (bottomBanners && !(0,lodash.isEmpty)(bottomBanners)) {
                    const bottomBannersValue = JSON.parse(bottomBanners.value);
                    ;
                    setBottomBanners(bottomBannersValue);
                }
            }
        }
    }, [
        page
    ]);
    var _slider_mediaDesktop_name, _firstBanner_link, _spacialBanner_link, _productMainCategories_find_permalink, _productCategories_find_permalink, _banner_link, _banner_target, _banner_link1, _banner_target1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "แลมป์ตั้น | หลอดไฟและอุปกรณ์ไฟฟ้า"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://lamptan-co-th.oss-ap-southeast-7.aliyuncs.com//home/main-sliders/01-mb-home-lighting-banner-1125x455px_th.jpeg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=G-CTV7JPNFX7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-analytics",
                children: "\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n        \n          gtag('config', 'G-CTV7JPNFX7');\n        "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                bg: {
                    base: "#eee",
                    lg: "#fff"
                },
                pb: 5,
                overflow: "hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                        isLoaded: mainSlider && mainSlider.length > 0,
                        children: mainSlider && mainSlider.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            maxWidth: "1920px",
                            margin: "0 auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                spaceBetween: 0,
                                slidesPerView: 1,
                                autoplay: {
                                    delay: 5000,
                                    disableOnInteraction: false
                                },
                                pagination: {
                                    clickable: true
                                },
                                modules: [
                                    swiper_esm/* Autoplay */.pt,
                                    swiper_esm/* Pagination */.tl
                                ],
                                onSwiper: (swiper)=>console.log(swiper),
                                children: mainSlider.map((slider, index)=>{
                                    var _slider_mediaDesktop;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        onClick: (e)=>{
                                            ;
                                            if (slider.link) {
                                                // log slider.link
                                                router.push(slider.link);
                                            }
                                            e.preventDefault();
                                        },
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            className: "swiper-slide-".concat(index),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: slider.mediaDesktop ? "".concat("https://storage.lamptan.co.th", "/").concat(slider.mediaDesktop.name) : "/images/empty-image.png",
                                                alt: (_slider_mediaDesktop_name = (_slider_mediaDesktop = slider.mediaDesktop) === null || _slider_mediaDesktop === void 0 ? void 0 : _slider_mediaDesktop.name) !== null && _slider_mediaDesktop_name !== void 0 ? _slider_mediaDesktop_name : "",
                                                width: 1920,
                                                height: 520,
                                                quality: 90,
                                                style: {
                                                    width: "100%",
                                                    height: "auto"
                                                }
                                            })
                                        })
                                    }, index);
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                            ratio: 32 / 9,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {})
                        })
                    }),
                    firstBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        maxWidth: "1920px",
                        margin: "0 auto",
                        children: firstBanner.mediaDesktop || firstBanner.mediaMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            mb: {
                                base: 0,
                                lg: 10
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (_firstBanner_link = firstBanner.link) !== null && _firstBanner_link !== void 0 ? _firstBanner_link : "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSingleBanner/* default */.Z, {
                                    banner: firstBanner,
                                    desktopWidth: 1920,
                                    desktopHeight: 520,
                                    mobileWidth: 500,
                                    mobileHeight: 150
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    }),
                    featuredCategories && featuredCategories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                            maxWidth: "900px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeFeaturedCategoriesSection/* default */.Z, {
                                featuredCategories: featuredCategories
                            })
                        })
                    }),
                    spacialBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                            maxW: "900px",
                            children: spacialBanner.mediaDesktop || spacialBanner.mediaMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (_spacialBanner_link = spacialBanner.link) !== null && _spacialBanner_link !== void 0 ? _spacialBanner_link : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSingleBanner/* default */.Z, {
                                        banner: spacialBanner,
                                        desktopWidth: 1920,
                                        desktopHeight: 520,
                                        mobileWidth: 500,
                                        mobileHeight: 150
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                            maxW: "900px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSectionHeader, {
                                    title: t("home.specialPromotion"),
                                    viewAllLink: "/products?type=spacial-price"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeProductList, {
                                    query: productSpacialPriceQueryString
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                            maxW: "900px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSectionHeader, {
                                    title: t("home.bestSeller"),
                                    viewAllLink: "/products?type=best-seller"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeProductList, {
                                    query: productBestSellerQueryString
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                            maxW: "900px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSectionHeader, {
                                    title: t("home.newArrival"),
                                    viewAllLink: "/products?type=new-arrival"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeProductList, {
                                    query: productNewArrivalQueryString ? productNewArrivalQueryString : query_string.stringify({
                                        isNewArrival: true,
                                        limit: 100
                                    })
                                })
                            ]
                        })
                    }),
                    productCategorySections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        children: productCategorySections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProductCategorySection/* default */.Z, {
                                section: section,
                                hideVerticalOnMobile: true
                            }, index))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        my: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                            maxW: "900px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                    mb: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        height: "180px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                    columns: 5,
                                    spacing: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                height: "100px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Skeleton */.Od, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                height: "100px"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 5,
                            lg: 10
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                                maxW: "900px",
                                mb: 4,
                                display: {
                                    md: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                    columns: 2,
                                    spacing: 4,
                                    children: productCategorySections.filter((section)=>section.layout === "vertical").map((section, index)=>{
                                        var _productMainCategories_find, _productCategories_find;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/product-categories/".concat((_productMainCategories_find_permalink = (_productMainCategories_find = productMainCategories.find((category)=>category.id === section.category)) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.permalink) !== null && _productMainCategories_find_permalink !== void 0 ? _productMainCategories_find_permalink : "", "/").concat((_productCategories_find_permalink = (_productCategories_find = productCategories.find((category)=>category.id === section.category)) === null || _productCategories_find === void 0 ? void 0 : _productCategories_find.permalink) !== null && _productCategories_find_permalink !== void 0 ? _productCategories_find_permalink : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat("https://storage.lamptan.co.th", "/").concat(section.mediaDesktop.name),
                                                alt: section.mediaDesktop.name,
                                                quality: 90,
                                                width: 400,
                                                height: 400
                                            }, index)
                                        }, index);
                                    })
                                })
                            }),
                            topBottomBanners && topBottomBanners.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                                    maxWidth: "900px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeBannerSection/* default */.Z, {
                                        bannerItems: topBottomBanners,
                                        columns: {
                                            base: 2,
                                            md: 3
                                        },
                                        spacing: {
                                            base: 4,
                                            md: 4,
                                            lg: 6
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        py: {
                            base: 4,
                            lg: 0
                        },
                        bg: "white",
                        mb: {
                            base: 0,
                            md: 0,
                            lg: 16
                        },
                        children: [
                            catalogBanners && catalogBanners.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                mb: {
                                    base: 5,
                                    md: 8,
                                    lg: 14
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                                    maxWidth: "900px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            textTransform: "uppercase",
                                            fontSize: {
                                                base: "xl",
                                                md: "3xl",
                                                lg: "4xl"
                                            },
                                            fontWeight: "400",
                                            color: "primary.500",
                                            mb: 4,
                                            children: "Lamptan Catalogue"
                                        }),
                                        catalogBannersTop && catalogBannersTop.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            mb: 6,
                                            children: catalogBannersTop.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                    mb: 6,
                                                    children: banner.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: (_banner_link = banner.link) !== null && _banner_link !== void 0 ? _banner_link : "",
                                                        target: (_banner_target = banner.target) !== null && _banner_target !== void 0 ? _banner_target : "_self",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: banner.media ? "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name) : "/image-icon/empty-image.png",
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520,
                                                            style: {
                                                                width: "100%",
                                                                height: "auto"
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name),
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520
                                                        })
                                                    })
                                                }, index))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeBannerSection/* default */.Z, {
                                            bannerItems: catalogBanners,
                                            columns: {
                                                base: 3
                                            },
                                            spacing: {
                                                base: 3,
                                                md: 6
                                            },
                                            linkTarget: "_blank"
                                        }),
                                        catalogBannersBottom && catalogBannersBottom.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            mb: 6,
                                            mt: 6,
                                            children: catalogBannersBottom.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                    mb: 6,
                                                    children: banner.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: (_banner_link1 = banner.link) !== null && _banner_link1 !== void 0 ? _banner_link1 : "",
                                                        target: (_banner_target1 = banner.target) !== null && _banner_target1 !== void 0 ? _banner_target1 : "_self",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: banner.media ? "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name) : "/image-icon/empty-image.png",
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520,
                                                            style: {
                                                                width: "100%",
                                                                height: "auto"
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "".concat("https://storage.lamptan.co.th", "/").concat(banner.media.name),
                                                            alt: "",
                                                            width: 1920,
                                                            height: 520
                                                        })
                                                    })
                                                }, index))
                                        })
                                    ]
                                })
                            }),
                            bottomBanners && bottomBanners.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                                    maxWidth: "900px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeBannerSection/* default */.Z, {
                                        bannerItems: bottomBanners,
                                        columns: {
                                            base: 3,
                                            md: 3
                                        },
                                        spacing: {
                                            base: 3,
                                            md: 6
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
HomePage.getLayout = (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RootLayout/* default */.Z, {
        children: page
    });
var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 36797:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(63573)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,1559,2077,2883,719,9806,1465,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);